import React, { useState } from 'react';
import PageTableLayout from '../components/PageTableLayout';

const breadcrumb = (
  <span>
    Home &nbsp;/&nbsp; Webber &nbsp;/&nbsp; <span className="text-gray-700">News & Notices</span>
  </span>
);

const columns = [
  { key: 'title', title: 'Title' },
  { key: 'date', title: 'Date' },
  { key: 'status', title: 'Status' },
];

const mockData = [
  { id: 1, title: 'School Annual Day Announced', date: '2025-07-10', status: 'Active' },
  { id: 2, title: 'Holiday on 15th August', date: '2025-07-08', status: 'Active' },
];

const NewsNotices = () => {
  const [data, setData] = useState(mockData);
  const filters = [
    <input key="title" className="border px-2 py-1 rounded text-sm" placeholder="Enter title" />,
    <input key="date" type="date" className="border px-2 py-1 rounded text-sm" />,
    <select key="status" className="border px-2 py-1 rounded text-sm">
      <option>Select Status</option>
      <option>Active</option>
      <option>Inactive</option>
    </select>,
    <button key="filter" className="bg-blue-600 text-white px-3 py-1 rounded text-xs">Filter</button>
  ];
  const handleEdit = (row) => alert(`Edit: ${row.title}`);
  const handleAddNew = () => alert('Add New News/Notice');
  return (
    <PageTableLayout
      title="News & Notices"
      breadcrumb={breadcrumb}
      columns={columns}
      data={data}
      filters={filters}
      onEdit={handleEdit}
      onAddNew={handleAddNew}
    />
  );
};

export default NewsNotices;
